import {format, parse, isValid} from 'date-fns';

export const getDateString = (
	date?: string | Date | number,
	showTime?: boolean,
) => {
	if (!date) return '';

	try {
		const dateFormats = [
			'MM/dd/yyyy',
			'MM-dd-yyyy',
			'yyyy-MM-dd',
			'yyyy-MM-dd HH:mm:ss',
			'MMMM d, yyyy (HH:mm:ss)',
			"yyyy-MM-dd'T'HH:mm:ssXXX",
		];

		let parsed: Date | undefined;

		if (date instanceof Date) {
			parsed = date;
		} else {
			const raw = String(date);
			for (const fmt of dateFormats) {
				const result = parse(raw, fmt, new Date());
				if (isValid(result)) {
					parsed = result;
					break;
				}
			}
		}
		if (!parsed) {
			// If we couldn't parse the date, return the original value
			return String(date);
		}

		return format(parsed, showTime ? 'MMMM d, yyyy h:mm:ss a' : 'MMMM d, yyyy');
	} catch (e) {
		// If parsing fails, just return the original value
		return String(date);
	}
};
